<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white">{{content.serviceCategory}}</h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
		<div class="container flex justify-between">
			<a-affix :offset-top="0">
				<div class="tabs">
					<div class="item" :class="currentTab==index?'active':''" @click.stop="tabChange(index)"
						v-for="(item,index) in content.process">
						<a @click="smooth" :href="item.id" class="flex align-center">
							<div v-if="currentTab==index" class="line2"></div><span
								class="margin-left-5">{{item.process}}</span>
						</a>
					</div>
				</div>
			</a-affix>
			<div class="contents">
				<div class="item" :id="item.characteristicPlateProcessId" v-for="(item,index) in content.details">
					<div class="item-title flex justify-between align-center">
						<div class="font-24 flex align-center"><div class="line"></div> <span class="margin-left-5"> {{item.process}}</span></div>
						<div class="reback" @click="reback" v-if="index==0">
							返回
							<a-icon type="rollback" />
						</div>
					</div>
					<div class="item-body" v-html="item.details">

					</div>
				</div>

			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default {
		components: {
			BaseNav,
			BaseFooter
		},
		data() {
			return {
				id: "",
				headBg: require("../../assets/company_bg.png"),
				itemBg: require("../../assets/service_item_bg.png"),
				content: {},
				currentTab: 0,
			}
		},
		mounted() {
			document.title = "雄安股权交易所-特色板块";
			this.id = this.$route.params.id;
			this.getHeadBg();
			this.getServiceInfo();
		},
		methods: {
			getHeadBg() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: 5,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			reback() {
				window.history.go(-1);
			},
			getServiceInfo() {
				this.$request({
					url: this.$api.special.getSpecialInfo,
					data: {
						characteristicPlateId: this.id
					}
				}).then((res) => {
					this.content = res.data.result;
					console.log(this.content)
				})
			},
			smooth(e) {
				let id = e.currentTarget.getAttribute("href");
				e.preventDefault();
				document.getElementById(id).scrollIntoView({
					block: 'start',
					behavior: 'smooth'
				})
			},
			tabChange(index) {
				this.currentTab = index;
			}
		}
	}
</script>

<style scoped="scoped">
	.tabs {
		width: 255px;
		padding: 40px;
		background-color: #fff;
		margin-top: 20px;
		margin-bottom: 20px;
		border-radius: 8px;
	}

	.tabs .item {
		padding-bottom: 15px;
		padding-top: 15px;
		border-bottom: 1px solid #F0F2FC;
	}

	.tabs .item:nth-of-type(1) {
		padding-top: 0px;
	}

	.tabs .item a {
		font-size: 22px;
		color: #1A1A1A;
	}

	.tabs .active a {
		font-size: 24px;
	}

	.contents {
		width: 920px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.contents .item {
		width: 100%;
		padding: 40px;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 24px;
	}


	.contents .item .item-title {
		padding-bottom: 24px;
		border-bottom: 1px solid #D9D9D9;
	}

	.contents .item .item-body {
		margin-top: 24px;
	}

	.line {
		width: 4px;
		height: 28px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.line2 {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	body {
		background-color: #F6F7FC;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/special/info.vue